import type { SidebarItem } from "@/app/admins/(authenticated)/sidebar"
import { ICON } from "./icon"

export const MENU: {
  CENTER: SidebarItem[]
  MEMBERS: SidebarItem[]
} = {
  CENTER: [
    {
      href: "/admins/center/dashboard",
      icon: ICON.DASHBOARD,
      label: "ダッシュボード",
    },
    {
      href: "/admins/center/property",
      icon: ICON.PROPERTY,
      label: "物件",
    },
    {
      href: "/admins/center/insurance",
      icon: ICON.INSURANCE,
      label: "メンテナンス",
    },
    {
      href: "/admins/center/continuing-property",
      icon: ICON.CONTINUING_PROPERTY,
      label: "継続物件",
    },
    {
      href: "/admins/center/vendor",
      icon: ICON.VENDOR,
      label: "加盟店",
      notification: "message",
    },
    {
      href: "/admins/center/account",
      icon: ICON.ACCOUNT,
      label: "ユーザ設定",
    },
    {
      href: "/admins/center/product",
      icon: ICON.PRODUCT,
      label: "商品設定",
    },
    {
      href: "/admins/center/branch",
      icon: ICON.BRANCH,
      label: "支店設定",
    },
    {
      href: "/admins/center/setting",
      icon: ICON.SETTING,
      label: "箇所設定",
    },
    {
      href: "/admins/center/news",
      icon: ICON.NEWS,
      label: "お知らせ",
    },
  ],
  MEMBERS: [
    {
      href: "/admins/members/dashboard",
      icon: ICON.DASHBOARD,
      label: "ダッシュボード",
    },
    {
      href: "/admins/members/property",
      icon: ICON.PROPERTY,
      label: "物件",
    },
    {
      href: "/admins/members/insurance",
      icon: ICON.INSURANCE,
      label: "メンテナンス",
    },
    {
      href: "/admins/members/continuing-property",
      icon: ICON.CONTINUING_PROPERTY,
      label: "継続物件",
    },
    {
      href: "/admins/members/vendor",
      icon: ICON.VENDOR,
      label: "加盟店",
      notification: "message",
    },
    {
      href: "/admins/members/account",
      icon: ICON.ACCOUNT,
      label: "ユーザ設定",
    },
    {
      href: "/admins/members/news",
      icon: ICON.NEWS,
      label: "お知らせ",
    },
  ],
}
